"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.auth = void 0;
exports.auth = function (axios) {
    return {
        putAuthSecondaryCert: function (putAuthSecondaryCertRequest) {
            return axios.put('/auth/secondary-cert', putAuthSecondaryCertRequest.data);
        },
        postAuthSecondaryCert: function (postAuthSecondaryCertRequest) {
            return axios.post('/auth/secondary-cert', postAuthSecondaryCertRequest.data);
        },
        postAuthToken: function (postAuthTokenRequest) {
            return axios.post('/auth/token', postAuthTokenRequest.data);
        },
        deleteAuthToken: function () {
            return axios.delete('/auth/token');
        },
        postAuthSms: function (postAuthSmsRequest) {
            return axios.post('/auth/sms', postAuthSmsRequest.data);
        },
        getAuthSms: function (getAuthSmsRequest) {
            return axios.get('/auth/sms', getAuthSmsRequest);
        },
        postCaptchaVerify: function (_a) {
            var _b = _a.params, code = _b.code, key = _b.key;
            return axios.post("/auth/captcha/verify?code=" + code + "&key=" + key);
        },
        getCaptchaImage: function (request) {
            return axios.get("/auth/captcha/image?key=" + request.params.key);
        },
        postAuthTokenServerApiCode: function (request) {
            return axios.post('/auth/token/server-api/code', request.data);
        },
        postAuthLogin: function (_a) {
            var _b = _a.data, id = _b.id, password = _b.password, adminType = _b.adminType;
            var request = new URLSearchParams();
            request.append('id', id);
            request.append('password', password);
            request.append('adminType', adminType);
            return axios.post('/auth/login', request, {
                headers: {
                    Version: '1.0',
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                }
            });
        }
    };
};
